
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "TopiramateDosageMethod",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/TopiramateDosageMethod.vue